import VideoContent from "./VideoContent";

// video element
const Video = ({data}) => {
    return(
      <>
        <section className="video p-top-70">
            <div className="container">
                <VideoContent videoContent={data}></VideoContent>
            </div>
        </section>
      </>
    );
}
  
export default Video;